<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
            prop_chartdata: Array,
            prop_labels: Array,
            prop_backgroundcolor: {
              type: Array, 
              default: function () { return [
                "#7292df",
                "#ad89e1",
                "#e27ccf",
                "#ff71ac",
                "#ff747e",
                "#ff884c",
                "#ffa600",
                "#3e95cd",
              ] }
            }
        },
  data() {
    return {
      chartdata: {
        labels: this.prop_labels,
          datasets: [{
              label: 'none',
              data: this.prop_chartdata,
              backgroundColor: this.prop_backgroundcolor,
          }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        title: {
            display: false,
        },
        tooltips: {
            enabled: false,
        },
        legend: {
            display: false,
        },
        layout: {
            padding: {
                left: 10,
                right: 15,
                top: 15,
                bottom: 10
            }
        },
        scales : {
            yAxes : [{
                ticks : {
                    beginAtZero : true
                }   
            }]
        }
      }
    }
  },

  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
};
</script>